<bspk-form-field data-bspk="dropdown-chip-field"
                 [controlId]="controlId()"
                 [errorMessage]="errorMessage() || errorState()"
                 [helperText]="helperText()"
                 [label]="label()"
                 [required]="required()">

  <div #overlayOrigin="cdkOverlayOrigin"
       aria-haspopup="listbox"
       cdkOverlayOrigin
       data-chip-input
       role="combobox"
       tabindex="0"
       [attr.aria-controls]="menuId"
       [attr.aria-expanded]="panelOpen() || null"
       [attr.aria-label]="label()"
       [attr.data-empty]="!value().length || null"
       [attr.data-invalid]="invalid() || !!errorState() || null"
       [attr.data-readonly]="readOnly() || null"
       [attr.data-size]="size()"
       [id]="controlId()"
       (blur)="handleBlur($event)"
      (click)="handleTriggerClick($event)"
       (keydown.enter)="toggle()"
       (keydown.space)="toggle(); $event.preventDefault()">
    <div data-chip-list>
      @for (option of selectedOptions(); track option.value) {
        <bspk-chip role="option"
                   [disabled]="disabled()"
                   [label]="option.label"
                   [removable]="!readOnly() && !disabled()"
                   (click)="$event.stopPropagation()"
                   (removed)="removeOption(option.value)" />
      }

      @if (!selectedOptions().length) {
        <span data-placeholder>{{ placeholder() }}</span>
      }

      <span data-chevron>
        <mat-icon>chevron_right</mat-icon>
      </span>
    </div>
  </div>

  <ng-template cdkConnectedOverlay
               cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
               cdkConnectedOverlayHasBackdrop
               [cdkConnectedOverlayOpen]="panelOpen()"
               [cdkConnectedOverlayOrigin]="overlayOrigin"
               (backdropClick)="closePanel()"
               (detach)="closePanel()"
  >
    <bspk-menu floating
               [disabled]="disabled()"
               [id]="menuId"
               [isMulti]="false"
               [itemCount]="clampedItemCount()"
               [items]="options()"
               [noResultsMessage]="noResultsMessage()"
               [selectedValues]="[]"
               [showSelectionControl]="false"
               [style.width]="menuWidth()"
               (selectedValuesChange)="addSelection($event)"
    />
  </ng-template>

</bspk-form-field>
